import React, { Component } from "react";

class SimpleTextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { label, mandatory, readOnly, onChange, typeInputCase, errorMessage, value, inputStyles, ...rest } =
      this.props;
    return (
      <div className={`margin-bottom-10px ${this.props.containerclassname}`}>
        <div className="margin-5px">
          <div className="txt-site txt-11 txt-main txt-bold">
            <h4>
              {label} {mandatory && <span style={{ color: "red" }}>*</span>}
            </h4>
          </div>
        </div>
        <textarea
          {...rest}
          value={value ?? ""}
          style={{
            backgroundColor: readOnly && "#E6E6E6",
            minHeight: "60px",
            resize: "vertical",
            ...(inputStyles|| {}),
          }}
          type="text"
          disabled={readOnly}
          className="txt txt-sekunder-color"
          onChange={(e) => {
            e.target.value =
              typeInputCase === "normal" ? e.target.value : e.target.value.toUpperCase();
            onChange(e);
          }}
        />
        {mandatory && errorMessage && (
          <p className="txt-site txt-11 color-red margin-top-5px">{errorMessage}</p>
        )}
      </div>
    );
  }
}

export default SimpleTextArea;
